/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { CustomerLocationStatusEnumType } from "./CustomerLocationStatusEnum"
import { RootStoreType } from "./index"


/**
 * CustomerProfileLocationDtoBase
 * auto generated base class for the model CustomerProfileLocationDtoModel.
 */
export const CustomerProfileLocationDtoModelBase = ModelBase
  .named('CustomerProfileLocationDto')
  .props({
    __typename: types.optional(types.literal("CustomerProfileLocationDto"), "CustomerProfileLocationDto"),
    address: types.union(types.undefined, types.null, types.string),
    /** Original address before geocoding */
    originalAddress: types.union(types.undefined, types.null, types.string),
    latitude: types.union(types.undefined, types.null, types.number),
    longitude: types.union(types.undefined, types.null, types.number),
    locationStatusId: types.union(types.undefined, types.null, CustomerLocationStatusEnumType),
    active: types.union(types.undefined, types.null, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CustomerProfileLocationDtoModelSelector extends QueryBuilder {
  get address() { return this.__attr(`address`) }
  get originalAddress() { return this.__attr(`originalAddress`) }
  get latitude() { return this.__attr(`latitude`) }
  get longitude() { return this.__attr(`longitude`) }
  get locationStatusId() { return this.__attr(`locationStatusId`) }
  get active() { return this.__attr(`active`) }
}
export function selectFromCustomerProfileLocationDto() {
  return new CustomerProfileLocationDtoModelSelector()
}

export const customerProfileLocationDtoModelPrimitives = selectFromCustomerProfileLocationDto().address.originalAddress.latitude.longitude.locationStatusId.active
